import { render, staticRenderFns } from "./BaseLoading.vue?vue&type=template&id=0fc62ae3&scoped=true"
import script from "./BaseLoading.vue?vue&type=script&lang=js"
export * from "./BaseLoading.vue?vue&type=script&lang=js"
import style0 from "./BaseLoading.vue?vue&type=style&index=0&id=0fc62ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc62ae3",
  null
  
)

export default component.exports